export default "//cdn.scentbird.com/assets/frontbird-site/images/placeholder_4f09b6.jpg";